import { Link } from 'react-router-dom';

export default function NotFound() {
    return (
        <section data-testid="notfound-page" className="min-h-[70vh] flex items-center">
            <div className="container-editorial py-32 text-center">
                <p className="overline">404 — Page not found</p>
                <h1 className="font-display text-5xl md:text-7xl font-light mt-6">
                    This path is still being walked.
                </h1>
                <p className="mt-6 text-aurika-ink max-w-xl mx-auto">
                    The page you are looking for seems to have wandered into the fields. Return to the home page and continue your journey.
                </p>
                <Link to="/" data-testid="notfound-home-cta" className="btn-primary mt-10">
                    Return home
                </Link>
            </div>
        </section>
    );
}
